import { render, staticRenderFns } from "./ProductMakePrice.vue?vue&type=template&id=b306b746&scoped=true&"
import script from "./ProductMakePrice.vue?vue&type=script&lang=js&"
export * from "./ProductMakePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b306b746",
  null
  
)

export default component.exports